module.exports = __webpack_public_path__ + "img/engelstrompete_4.d0a72223.jpg";